import { type NavbarProps, Navbar as SharedNavbar } from '@openx/components-core/lib/Navbar/Navbar.tsx';
import type { UserOption } from '@openx/components-core/lib/Navigation/UserPanel.tsx';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

export const Navbar = (props: Omit<NavbarProps, 'helperMenuConfig'>) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const helpMenuConfig = useMemo(
    () => [
      {
        link: 'https://docs.openx.com/resources/release-notes/index.html',
        title: t("What's New"),
      },
      {
        link: '/docs/openxselect/oxs-main/index.html',
        title: t('Product Documentation'),
      },
      { link: 'https://community.openx.com', title: t('Support') },
    ],
    [t]
  );

  const userPanelSettingsOptions: UserOption[] = [
    { action: () => navigate(`/terms`), label: t('Terms and Conditions') },
    { action: () => navigate(`/settings`), label: t('Settings'), showDivider: true },
  ];

  return (
    <SharedNavbar
      isOA
      helperMenuConfig={helpMenuConfig}
      userPanelSettingsOptions={userPanelSettingsOptions}
      {...props}
    />
  );
};
